import { compact, concat, some } from 'lodash';

import { ActionTypes } from './constants';
import updateQueryParameters from './updateQueryParameters';
import { getSearchParameters } from '../state';

const keysToIgnoreChangesFor = [
    'pageOffset',
    'pickerErrorOverride',
];

const updateParameters = (parameters = {}, shouldSearch = true) =>
    (dispatch, getState) => {
        const nextState = {
            pickerErrorOverride: false,
            ...parameters,
        };
        const prevState = getSearchParameters(getState());

        const paramsOtherThanIgnoredAreDifferent = some(nextState, (value, key) => {
            return !keysToIgnoreChangesFor.includes(key) && prevState[key] !== undefined && value !== prevState[key];
        });

        if (paramsOtherThanIgnoredAreDifferent) {
            nextState.pageOffset = 0;
        }

        const excludeSpecialties = compact(concat(prevState.excludeSpecialties, nextState.excludeSpecialties));
        if (excludeSpecialties.length) {
            nextState.excludeSpecialties = excludeSpecialties;
        }

        dispatch({
            type: ActionTypes.UPDATE_PARAMETERS,
            payload: {
                ...prevState,
                ...nextState,
            },
        });

        if (shouldSearch) {
            return dispatch(updateQueryParameters());
        }
    };

export default updateParameters;
